import { useState } from "react";
import {
    Accordion,
    AccordionBody,
    AccordionHeader,
    AccordionItem,
    Button,
    Col,
    Container,
    Row,
} from "reactstrap";
import "./CourseSyllabus.css";

const CourseSyllabus = ({
    courseName = "Course",
    syllabus = {},
}) => {

    const levels = [
        {
            id: "basic",
            label: "Basic",
            description: "Build a strong foundation",
        },
        {
            id: "intermediate",
            label: "Intermediate",
            description: "Develop practical skills",
        },
        {
            id: "advanced",
            label: "Advanced",
            description: "Master industry-level concepts",
        },
    ];

    const availableLevels = levels.filter(
        (level) => syllabus[level.id]?.length > 0
    );

    const [activeLevel, setActiveLevel] = useState(
        availableLevels[0]?.id || "basic"
    );

    const [open, setOpen] = useState("");

    const toggle = (id) => {
        setOpen(open === id ? "" : id);
    };

    const currentSyllabus = syllabus[activeLevel] || [];

    const handleLevelChange = (level) => {
        setActiveLevel(level);
        setOpen("");
    };

    return (
        <section className="course-syllabus-section">

            <Container>

                {/* =================================
                    Header
                ================================= */}

                <div className="course-syllabus-header">

                    <span className="course-syllabus-badge">
                        COURSE SYLLABUS
                    </span>

                    <h2>
                        {courseName}{" "}
                        <span>Syllabus</span>
                    </h2>

                    <p>
                        Follow a structured learning path from fundamentals
                        to advanced concepts with practical, industry-focused
                        training.
                    </p>

                </div>


                {/* =================================
                    Level Selector
                ================================= */}

                <div className="syllabus-level-wrapper">

                    <Row className="g-2">

                        {availableLevels.map((level) => (

                            <Col
                                md="4"
                                key={level.id}
                            >

                                <Button
                                    className={`syllabus-level-btn ${
                                        activeLevel === level.id
                                            ? "active"
                                            : ""
                                    }`}
                                    onClick={() =>
                                        handleLevelChange(level.id)
                                    }
                                >

                                    <span className="syllabus-level-number">
                                        {level.id === "basic"
                                            ? "01"
                                            : level.id === "intermediate"
                                            ? "02"
                                            : "03"}
                                    </span>

                                    <span className="syllabus-level-info">

                                        <strong>
                                            {level.label}
                                        </strong>

                                        <small>
                                            {level.description}
                                        </small>

                                    </span>

                                </Button>

                            </Col>
                        ))}

                    </Row>

                </div>


                {/* =================================
                    Active Level Heading
                ================================= */}

                <div className="syllabus-active-header">

                    <div>
                        <span>
                            {activeLevel === "basic"
                                ? "LEVEL 01"
                                : activeLevel === "intermediate"
                                ? "LEVEL 02"
                                : "LEVEL 03"}
                        </span>

                        <h3>
                            {levels.find(
                                (level) =>
                                    level.id === activeLevel
                            )?.label}{" "}
                            Level
                        </h3>
                    </div>

                    <div className="syllabus-topic-count">
                        {currentSyllabus.length} Topics
                    </div>

                </div>


                {/* =================================
                    Syllabus Accordion
                ================================= */}

                <div className="course-syllabus-accordion">

                    <Accordion
                        flush
                        open={open}
                        toggle={toggle}
                    >

                        {currentSyllabus.map((item, index) => (

                            <AccordionItem
                                key={item.id}
                                className={
                                    open === item.id
                                        ? "syllabus-item syllabus-item-open"
                                        : "syllabus-item"
                                }
                            >

                                <AccordionHeader
                                    targetId={item.id}
                                >

                                    <div className="syllabus-title-wrapper">

                                        <span className="syllabus-number">
                                            {String(index + 1).padStart(
                                                2,
                                                "0"
                                            )}
                                        </span>

                                        <span className="syllabus-title">
                                            {item.title}
                                        </span>

                                    </div>

                                </AccordionHeader>


                                <AccordionBody
                                    accordionId={item.id}
                                >

                                    <div className="syllabus-content">

                                        {item.content?.map(
                                            (topic, topicIndex) => (

                                                <div
                                                    className="syllabus-topic"
                                                    key={topicIndex}
                                                >
                                                    <span className="topic-dot">
                                                    </span>

                                                    <span>
                                                        {topic}
                                                    </span>
                                                </div>

                                            )
                                        )}

                                    </div>

                                </AccordionBody>

                            </AccordionItem>

                        ))}

                    </Accordion>

                </div>

            </Container>

        </section>
    );
};

export default CourseSyllabus;